(function () {
  var WISHLIST_KEY = 'stilloak_wishlist_handles';
  var FREE_SHIPPING_THRESHOLD = 50000; // £500 in pence - adjust as needed

  /* ========================================
     Cart Drawer
     ======================================== */

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  function updateCartBadges(count) {
    document.querySelectorAll('.cart-badge').forEach(function (badge) {
      badge.textContent = count;
      badge.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function renderCartDrawer(cart) {
    var body = document.querySelector('.cart-drawer-body');
    var footer = document.querySelector('.cart-drawer-footer');
    if (!body || !footer) return;

    updateCartBadges(cart.item_count);

    var headerCount = document.querySelector('.drawer-count');
    if (headerCount) {
      headerCount.textContent = '(' + cart.item_count + ')';
    }

    if (cart.item_count === 0) {
      body.innerHTML =
        '<div class="drawer-empty">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>' +
          '<h3>Your cart is empty</h3>' +
          '<p>Add some items to get started.</p>' +
          '<a href="/collections/all" class="btn-shop-empty">Browse Collection</a>' +
        '</div>';
      footer.style.display = 'none';
      return;
    }

    footer.style.display = '';

    var html = '<div class="drawer-items-list">';
    cart.items.forEach(function (item) {
      var variantInfo = '';
      if (item.variant_options && item.variant_options.length) {
        var options = item.variant_options.filter(function (v) { return v && v !== 'Default Title'; });
        if (options.length) {
          variantInfo = '<div class="drawer-item-variant">' + options.join(' / ') + '</div>';
        }
      }

      html +=
        '<div class="drawer-item" data-key="' + item.key + '">' +
          '<div class="drawer-item-image">' +
            '<img src="' + (item.image ? item.image.replace(/(\.[^.]+)(\?.*)?$/, '_120x120$1$2') : '') + '" alt="' + item.title.replace(/"/g, '&quot;') + '">' +
          '</div>' +
          '<div class="drawer-item-details">' +
            '<div class="drawer-item-title">' + item.product_title + '</div>' +
            variantInfo +
            '<div class="drawer-item-bottom">' +
              '<div class="drawer-item-qty">' +
                '<button type="button" class="drawer-qty-btn drawer-qty-minus" aria-label="Decrease">-</button>' +
                '<input type="number" class="drawer-qty-input" value="' + item.quantity + '" min="0" data-key="' + item.key + '">' +
                '<button type="button" class="drawer-qty-btn drawer-qty-plus" aria-label="Increase">+</button>' +
              '</div>' +
              '<div class="drawer-item-price">' + formatMoney(item.line_price) + '</div>' +
            '</div>' +
          '</div>' +
          '<button class="drawer-item-remove" data-key="' + item.key + '" aria-label="Remove">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6L6 18M6 6l12 12"/></svg>' +
          '</button>' +
        '</div>';
    });
    html += '</div>';
    body.innerHTML = html;

    // Subtotal
    var subtotalEl = document.querySelector('.drawer-subtotal-price');
    if (subtotalEl) {
      subtotalEl.textContent = formatMoney(cart.total_price);
    }

    // Shipping bar
    updateShippingBar(cart.total_price);

    // Rebind events
    bindDrawerEvents();
  }

  function updateShippingBar(total) {
    var bar = document.querySelector('.drawer-shipping-bar');
    if (!bar) return;
    var remaining = FREE_SHIPPING_THRESHOLD - total;
    var pct = Math.min(100, (total / FREE_SHIPPING_THRESHOLD) * 100);
    var textEl = bar.querySelector('.drawer-shipping-text');
    var fillEl = bar.querySelector('.shipping-progress-fill');

    if (remaining > 0) {
      textEl.innerHTML = 'Free Shipping!';
    } else {
      textEl.innerHTML = '<strong>You\'ve qualified for free shipping!</strong>';
    }
    fillEl.style.width = pct + '%';
  }

  function formatMoney(cents) {
    var val = (cents / 100).toFixed(2);
    return '\u00A3' + val;
  }

  function changeCartItem(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
      credentials: 'same-origin'
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      renderCartDrawer(cart);
      return cart;
    });
  }

  function bindDrawerEvents() {
    // Quantity minus
    document.querySelectorAll('.drawer-qty-minus').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = btn.parentElement.querySelector('.drawer-qty-input');
        var key = input.getAttribute('data-key');
        var qty = parseInt(input.value) - 1;
        if (qty < 0) qty = 0;
        changeCartItem(key, qty);
      });
    });

    // Quantity plus
    document.querySelectorAll('.drawer-qty-plus').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = btn.parentElement.querySelector('.drawer-qty-input');
        var key = input.getAttribute('data-key');
        var qty = parseInt(input.value) + 1;
        changeCartItem(key, qty);
      });
    });

    // Quantity input change
    document.querySelectorAll('.drawer-qty-input').forEach(function (input) {
      input.addEventListener('change', function () {
        var key = input.getAttribute('data-key');
        var qty = parseInt(input.value);
        if (isNaN(qty) || qty < 0) qty = 0;
        changeCartItem(key, qty);
      });
    });

    // Remove
    document.querySelectorAll('.drawer-item-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-key');
        changeCartItem(key, 0);
      });
    });
  }

  function openCartDrawer() {
    var drawer = document.querySelector('.cart-drawer');
    var overlay = document.querySelector('.cart-drawer-overlay');
    if (drawer) drawer.classList.add('open');
    if (overlay) overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    getCart().then(renderCartDrawer);
  }

  function closeCartDrawer() {
    var drawer = document.querySelector('.cart-drawer');
    var overlay = document.querySelector('.cart-drawer-overlay');
    if (drawer) drawer.classList.remove('open');
    if (overlay) overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  /* ========================================
     Wishlist
     ======================================== */

  function getWishlist() {
    try {
      var data = localStorage.getItem(WISHLIST_KEY);
      return data ? JSON.parse(data) : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(handles) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(handles));
    updateWishlistBadge();
  }

  function updateWishlistBadge() {
    var list = getWishlist();
    document.querySelectorAll('.wishlist-badge').forEach(function (badge) {
      badge.textContent = list.length;
      badge.style.display = list.length > 0 ? 'flex' : 'none';
    });
  }

  function removeFromWishlist(handle) {
    var list = getWishlist();
    list = list.filter(function (h) { return h !== handle; });
    saveWishlist(list);
    renderWishlistDrawer();
  }

  function renderWishlistDrawer() {
    var body = document.querySelector('.wishlist-drawer-body');
    if (!body) return;

    var list = getWishlist();
    updateWishlistBadge();

    if (list.length === 0) {
      body.innerHTML =
        '<div class="wishlist-empty">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>' +
          '<h3>Your wishlist is empty</h3>' +
          '<p>Save items you love for later.</p>' +
          '<a href="/collections/all" class="btn-shop-empty">Browse Collection</a>' +
        '</div>';
      return;
    }

    var html = '<div class="wishlist-items-list">';
    list.forEach(function (handle) {
      html +=
        '<div class="wishlist-item" data-handle="' + handle + '">' +
          '<div class="wishlist-item-image">' +
            '<img src="" alt="" data-wishlist-img="' + handle + '">' +
          '</div>' +
          '<div class="wishlist-item-details">' +
            '<div class="wishlist-item-title" data-wishlist-title="' + handle + '"><a href="/products/' + handle + '">Loading...</a></div>' +
            '<div class="wishlist-item-price" data-wishlist-price="' + handle + '"></div>' +
            '<button class="wishlist-add-to-cart" data-wishlist-add="' + handle + '">Add to Cart</button>' +
          '</div>' +
          '<button class="wishlist-item-remove" data-wishlist-remove="' + handle + '" aria-label="Remove">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6L6 18M6 6l12 12"/></svg>' +
          '</button>' +
        '</div>';
    });
    html += '</div>';
    body.innerHTML = html;

    bindWishlistEvents();

    // Fetch product data for each item
    list.forEach(function (handle) {
      fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (product) {
          var img = document.querySelector('[data-wishlist-img="' + handle + '"]');
          if (img && product.featured_image) {
            img.src = product.featured_image.replace(/(\.[^.]+)(\?.*)?$/, '_120x120$1$2');
            img.alt = product.title;
          }
          var title = document.querySelector('[data-wishlist-title="' + handle + '"]');
          if (title) {
            title.innerHTML = '<a href="/products/' + handle + '">' + product.title + '</a>';
          }
          var price = document.querySelector('[data-wishlist-price="' + handle + '"]');
          if (price) {
            price.textContent = formatMoney(product.price);
          }
          var addBtn = document.querySelector('[data-wishlist-add="' + handle + '"]');
          if (addBtn) {
            addBtn.setAttribute('data-variant-id', product.variants[0].id);
          }
        })
        .catch(function () {});
    });
  }

  function bindWishlistEvents() {
    // Remove from wishlist
    document.querySelectorAll('[data-wishlist-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var handle = btn.getAttribute('data-wishlist-remove');
        removeFromWishlist(handle);
      });
    });

    // Add to cart from wishlist
    document.querySelectorAll('[data-wishlist-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;

        btn.textContent = 'Adding...';
        btn.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId), quantity: 1 }),
          credentials: 'same-origin'
        })
        .then(function (r) { return r.json(); })
        .then(function () {
          btn.textContent = 'Added!';
          return getCart();
        })
        .then(function (cart) {
          renderCartDrawer(cart);
          updateCartBadges(cart.item_count);
        })
        .catch(function () {
          btn.textContent = 'Add to Cart';
          btn.disabled = false;
        });
      });
    });
  }

  function openWishlistDrawer() {
    var drawer = document.querySelector('.wishlist-drawer');
    var overlay = document.querySelector('.wishlist-drawer-overlay');
    if (drawer) drawer.classList.add('open');
    if (overlay) overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    renderWishlistDrawer();
  }

  function closeWishlistDrawer() {
    var drawer = document.querySelector('.wishlist-drawer');
    var overlay = document.querySelector('.wishlist-drawer-overlay');
    if (drawer) drawer.classList.remove('open');
    if (overlay) overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  /* ========================================
     Cart Page Quantity Controls
     ======================================== */

  function initCartPage() {
    var cartForm = document.getElementById('cart-form');
    if (!cartForm) return;

    // Quantity minus
    cartForm.querySelectorAll('.qty-minus').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = btn.parentElement.querySelector('.qty-input');
        var qty = parseInt(input.value) - 1;
        if (qty < 0) qty = 0;
        input.value = qty;
        updateCartPageItem(input.getAttribute('data-key'), qty);
      });
    });

    // Quantity plus
    cartForm.querySelectorAll('.qty-plus').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = btn.parentElement.querySelector('.qty-input');
        var qty = parseInt(input.value) + 1;
        input.value = qty;
        updateCartPageItem(input.getAttribute('data-key'), qty);
      });
    });

    // Quantity input change
    cartForm.querySelectorAll('.qty-input').forEach(function (input) {
      input.addEventListener('change', function () {
        var qty = parseInt(input.value);
        if (isNaN(qty) || qty < 0) qty = 0;
        input.value = qty;
        updateCartPageItem(input.getAttribute('data-key'), qty);
      });
    });

    // Remove buttons
    cartForm.querySelectorAll('.cart-item-remove').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var key = link.getAttribute('data-key');
        updateCartPageItem(key, 0);
      });
    });
  }

  function updateCartPageItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
      credentials: 'same-origin'
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      updateCartBadges(cart.item_count);
      if (quantity === 0) {
        var item = document.querySelector('.cart-item[data-key="' + key + '"]');
        if (item) {
          item.style.transition = 'opacity 0.3s, transform 0.3s';
          item.style.opacity = '0';
          item.style.transform = 'translateX(-20px)';
          setTimeout(function () {
            item.remove();
            checkCartPageEmpty(cart);
          }, 300);
        }
      } else {
        // Update line total
        var cartItem = document.querySelector('.cart-item[data-key="' + key + '"]');
        if (cartItem) {
          cart.items.forEach(function (ci) {
            if (ci.key === key) {
              var lineTotal = cartItem.querySelector('.cart-item-line-total');
              if (lineTotal) lineTotal.textContent = formatMoney(ci.line_price);
            }
          });
        }
        updateCartPageSummary(cart);
      }
    });
  }

  function updateCartPageSummary(cart) {
    var subtotal = document.querySelector('.cart-subtotal');
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
    var total = document.querySelector('.cart-total-price');
    if (total) total.textContent = formatMoney(cart.total_price);
  }

  function checkCartPageEmpty(cart) {
    if (cart.item_count === 0) {
      window.location.reload();
    } else {
      updateCartPageSummary(cart);
    }
  }

  /* ========================================
     Initialize
     ======================================== */

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  ready(function () {
    // Cart drawer open/close
    document.querySelectorAll('.cart-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        // Only open drawer if we have one
        if (document.querySelector('.cart-drawer')) {
          e.preventDefault();
          openCartDrawer();
        }
      });
    });

    document.querySelectorAll('.cart-drawer-close').forEach(function (btn) {
      btn.addEventListener('click', closeCartDrawer);
    });

    document.querySelectorAll('.cart-drawer-overlay').forEach(function (overlay) {
      overlay.addEventListener('click', closeCartDrawer);
    });

    // Wishlist drawer open/close
    document.querySelectorAll('.wishlist-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openWishlistDrawer();
      });
    });

    document.querySelectorAll('.wishlist-drawer-close').forEach(function (btn) {
      btn.addEventListener('click', closeWishlistDrawer);
    });

    document.querySelectorAll('.wishlist-drawer-overlay').forEach(function (overlay) {
      overlay.addEventListener('click', closeWishlistDrawer);
    });

    // Init wishlist badge
    updateWishlistBadge();

    // Init cart page controls
    initCartPage();

    // Escape key closes drawers
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeCartDrawer();
        closeWishlistDrawer();
      }
    });
  });

  // Expose for use from other scripts (e.g. product page add-to-cart)
  window.StilloakCart = {
    getCart: getCart,
    renderCartDrawer: renderCartDrawer,
    openCartDrawer: openCartDrawer,
    closeCartDrawer: closeCartDrawer,
    updateCartBadges: updateCartBadges,
    formatMoney: formatMoney,
    getWishlist: getWishlist,
    saveWishlist: saveWishlist,
    updateWishlistBadge: updateWishlistBadge
  };
})();
